import { RouterProvider } from 'react-router/dom';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { CustomRouter } from './admin/router/CustomRouter';
import './index.css';

const root = createRoot(
	document.getElementById('fiveprayer') as HTMLElement
);
root.render(
	<React.StrictMode>
		<RouterProvider 
		 router={CustomRouter} />
	</React.StrictMode>
);
